/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SeriesRepetitionEnum } from './seriesRepetitionEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface CalendarBlockerCreate { 
    fromDate: string;
    toDate: string;
    seriesEndDate?: string;
    therapistId: number;
    blockerTypeId: number;
    reason?: string;
    weekInterval?: number;
    repetitionType?: SeriesRepetitionEnum;
    seriesBlockerAmount?: number;
}
export namespace CalendarBlockerCreate {
}

export const CalendarBlockerCreate_fromDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarBlockerCreate_toDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarBlockerCreate_seriesEndDate_Validators: ValidatorFn[] =
    [ ];

export const CalendarBlockerCreate_therapistId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarBlockerCreate_blockerTypeId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarBlockerCreate_reason_Validators: ValidatorFn[] =
    [ ];

export const CalendarBlockerCreate_weekInterval_Validators: ValidatorFn[] =
    [ ];

export const CalendarBlockerCreate_repetitionType_Validators: ValidatorFn[] =
    [ ];

export const CalendarBlockerCreate_seriesBlockerAmount_Validators: ValidatorFn[] =
    [  Validators.min(2),];


